import {Component} from '@angular/core';
import {BaseComponent} from "../../../shared/base/base.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true
})

export class HomeComponent extends BaseComponent {
  constructor(
  ) {
    super();
  }
}
